export class CByteArray extends Uint8Array {
	protected m_View:DataView;
	private m_position:number;
	private m_Size:number;
	
	constructor(length:number);
	constructor(buf:ArrayBuffer);
	constructor(array: ArrayLike<number> | ArrayBuffer);
	constructor(args:any) {
        super(args);
		//CGame.DebugLog(typeof(args)+":"+this.buffer.byteLength);
        if( typeof(args) == "number" ) this.Reset();
		this.m_View = new DataView(this.buffer);
		this.m_position = 0;
		this.m_Size = this.buffer.byteLength;
    }

	public resetPosition():void { this.m_position = 0; }
	public get Position():number { return this.m_position; }
	public set Position(pos:number) { this.m_position = pos; }

    public Reset(v:number = 0):void {
        //this.forEach((element, index, array) => {array[index] = v});
		this.fill(v);
		//for( var i = 0; i <this.length; i ++ ) this[i] = v;
    }

	public readChar():number {
		var ret:number = this.m_View.getInt8(this.m_position);
		this.m_position += 1;
        return ret;
    }

	public readShort():number {
		var ret:number = this.m_View.getInt16(this.m_position, true);
		this.m_position += 2;
        return ret;
    }

    public readInt():number {
		var ret:number = this.m_View.getInt32(this.m_position, true);
		this.m_position += 4;
        return ret;
    }

	public readByte():number {
		var ret:number = this.m_View.getUint8(this.m_position);
		this.m_position += 1;
        return ret;
    }

	public readWord():number {
		var ret:number = this.m_View.getUint16(this.m_position, true);
		this.m_position += 2;
        return ret;
    }

    public readDWord():number {
		var ret:number = this.m_View.getUint32(this.m_position, true);
		this.m_position += 4;
        return ret;
    }

	public readUInt64():number {
		var ret:number = this.GetUint64(this.m_position, true);
		this.m_position += 8;
        return ret;
    }

	public readDouble():number {
		var ret:number = this.GetDouble(this.m_position);
		this.m_position += 8;
        return ret;
    }

	public readUTFBytes(len:number):string {
		var i:number;
		for(i = 0; i < len; i ++) {
			if( this[i+this.m_position] == 0 ) break;
		}
		var charArray = new Uint8Array(this.buffer, this.m_position, i);
		this.m_position += len;
		var str = new TextDecoder("utf-8").decode(charArray);
		return str;
	}

	public readBytes(dest:Uint8Array, ofs:number, size:number):void {
		for(var i = 0; i < size; i ++) {
			dest[ofs++] = this[this.m_position++];
		}
	}

	public Copy(ofs:number, src:ArrayBuffer|Uint8Array, ofsS:number, size:number):void {
		this.m_Size = ofs + size;
		var srcAry = new Uint8Array(src);
		for(var i = 0; i < size; i ++) {
			this[ofs++] = srcAry[ofsS++];
		}
	}

	public SetUTFBytes(ofs:number, value:string):number {
		var uint8array = new TextEncoder().encode(value);
		for( var i = 0; i < uint8array.length; i ++ ) {
			if( (ofs+i) >= (this.length-1) ) break;
			this[ofs+i] = uint8array[i];
		}
		this[ofs+i] = 0;
		return uint8array.length+1;
	}

	public GetUTFBytes(ofs:number, len:number):string {
		var i:number;
		for(i = 0; i < len; i ++) {
			if( this[i+ofs] == 0 ) break;
		}
		var charArray = new Uint8Array(this.buffer, ofs, i);
		var str = new TextDecoder("utf-8").decode(charArray);
		return str;
	}

	public GetChar(offset:number):number {
        return this.m_View.getInt8(offset);
    }

	public GetShort(offset:number):number {
        return this.m_View.getInt16(offset, true);
    }

    public GetInt(offset:number):number {
        return this.m_View.getInt32(offset, true);
    }

	public GetByte(offset:number):number {
        return this.m_View.getUint8(offset);
    }

	public GetBytes(sofs:number, dest:Uint8Array, dofs:number, size:number):void {
		for(var i = 0; i < size; i ++) {
			dest[dofs++] = this.m_View.getUint8(sofs++);
		}
	}

	public GetWord(offset:number):number {
        return this.m_View.getUint16(offset, true);
    }

    public GetDWord(offset:number):number {
        return this.m_View.getUint32(offset, true);
    }

	public GetDouble(offset:number):number {
		return this.m_View.getFloat64(offset, true);
	}

	public GetUint64(offset:number, littleEndian:boolean):number {
		// split 64-bit number into two 32-bit (4-byte) parts
		const left = this.m_View.getUint32(offset, littleEndian);
		const right = this.m_View.getUint32(offset + 4, littleEndian);
	  
		// combine the two 32-bit values
		const combined = littleEndian
		  ? left + 2 ** 32 * right
		  : 2 ** 32 * left + right;
	  
		if (!Number.isSafeInteger(combined))
		  console.warn(combined, "exceeds MAX_SAFE_INTEGER. Precision may be lost");
	  
		return combined;
	}

	public SetChar(offset:number, v:number):void {
		this.m_View.setInt8(offset, v);
    }

	public SetShort(offset:number, v:number):void {
        this.m_View.setInt16(offset, v, true);
    }

    public SetInt(offset:number, v:number):void {
        this.m_View.setInt32(offset, v, true);
    }

	public SetByte(offset:number, v:number):void {
        this.m_View.setUint8(offset, v);
    }

	public SetWord(offset:number, v:number):void {
        this.m_View.setUint16(offset, v, true);
    }

    public SetDWord(offset:number, v:number):void {
        this.m_View.setUint32(offset, v, true);
    }

	public SetDouble(offset:number, v:number):void {
        this.m_View.setFloat64(offset, v, true);
    }

	public get size():number { return this.m_Size; }
	public set size(v:number) { this.m_Size = v; }
}

